<template>
  <div>
    {{ ActDescBtn }}
    <table
      :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8"
      style="position: absolute"
      width="100%"
    >
      <tr height="48px" max-height="48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Imprime las Ventas Generadas por Vendedor'"
          :titulo="'Ventas por Vendedor'"
          @MethodAnular="anular"
          @MethodEliminar="remove"
          @MethodGuardar="save"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newwnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </tr>

      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px"></i>
                      ver
                    </v-btn>
                    <v-btn
                      color="deep-purple accent-2"
                      dark
                      small
                      @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                    >
                      <i class="fa fa-print" style="font-size: 25px"></i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!--                <BarraBusqueda2-->
                <!--                    :url="-->
                <!--                $hostname + $hName + '/services/tipocliente/findalltipoclientes'-->
                <!--              "-->
                <!--                    :nombre="'Tipo de Clientes'"-->
                <!--                    :headers="headers"-->
                <!--                    :slotname="'item.descripcion'"-->
                <!--                    :emitnombre="'emitReportesVentasVendedor'"-->
                <!--                    :SeachNombre="'Búsqueda por descripcion '"-->
                <!--                    :slotlist="slotlist"-->
                <!--                />-->
              </template>
            </v-tooltip>
          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <!-- Formulario-Ventas por Vendedor -->
            <v-container>
              <v-card color="grey lighten-3">
                <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
                  <v-avatar size="45" tile>
                    <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png" />
                  </v-avatar>
                  <span class="font-weight-light" style="font-size: 20px">Reporte Ventas por Vendedor</span>

                  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
                  <!-- style="color:white;" -->
                  <!-- <i class=""> </i> -->

                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn
                    color="grey darken-4"
                    fab
                    small
                    @click="cerrarmodalcuenta"
                  >
                   <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
                  </v-btn> -->
                </v-toolbar>

                <hr />

                <v-container style="border: 1px solid #000000">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  desde  -->
                        <v-text-field
                          v-model="VentasVendedor.desde"
                          :rules="[$rules.required]"
                          dense
                          label="Desde:"
                          outlined
                          type="date"
                          @blur="BlurDesde"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!-------------------------------------------------- Sucursal -->
                        <v-combobox
                          v-model="VentasVendedor.sucursal"
                          :items="RSucursal"
                          autocomplete="off"
                          dense
                          item-text="descripcion"
                          label="Sucursal:"
                          outlined
                          @blur="SelctCbSucursal"
                          @focus="cargarSucursal"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-sitemap" style="font-size: 20px"></i>
                          </template>
                        </v-combobox>

                        <!-- ----------------------------- Tipo de Cliente -->
                        <v-autocomplete
                          v-model="VentasVendedor.tipoCliente"
                          :items="tipoClienteList"
                          autocomplete="off"
                          clearable
                          dense
                          item-text="descripcion"
                          label="Tipo de Cliente:"
                          outlined
                          return-object
                          @focus="findAllTipoCliente"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-users" style="font-size: 20px"></i>
                          </template>
                        </v-autocomplete>

                        <v-combobox
                          v-model="VentasVendedor.vendedor"
                          :items="RVendedores"
                          autocomplete="off"
                          dense
                          item-text="codVenDesc"
                          label="Vendedor:"
                          outlined
                          @focus="cargarVendedores"
                        >
                        <template slot="item" slot-scope="item">
                        <span style="display:none;">{{ item.item.codVenDesc = `${item.item.codigo} - ${item.item.nombre.trim()} ` }}</span>
                            <span  class="fontSize13"><b>{{ item.item.codigo }}</b> - {{ item.item.nombre.trim() }} </span>
                        </template>

                          <template v-slot:prepend>
                            <i class="fa fa-sign-language" style="font-size: 20px"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                      <!-- fn columna 1 -->

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  Hasta  -->
                        <v-text-field
                          v-model="VentasVendedor.hasta"
                          :rules="[$rules.required]"
                          dense
                          label="Hasta:"
                          outlined
                          type="date"
                          @blur="BlurHasta"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <v-combobox
                          v-model="VentasVendedor.tipo"
                          :items="RComision"
                          autocomplete="off"
                          dense
                          item-text="descripcion"
                          label="Calcular comisión:"
                          outlined
                          @blur="SelctCbTipo"
                          @change="changeDsc"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-hashtag" style="font-size: 20px"></i>
                          </template>
                        </v-combobox>

                        <!--- Subtipo de Cliente --->
                        <v-autocomplete
                          v-model="VentasVendedor.subtipoCliente"
                          :items="VentasVendedor.tipoCliente ? VentasVendedor.tipoCliente.subtipos : []"
                          clearable
                          dense
                          item-text="descripcion"
                          label="Subtipo de Cliente:"
                          outlined
                          return-object
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-user-plus" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-autocomplete>

                        <v-col cols="12" md="12" sm="12">
                          <v-row no-gutters>
                            <v-col cols="12" md="6" sm="6">
                              <v-switch
                                v-model="VentasVendedor.resumen"
                                class="mt-0"
                                color="teal"
                                hide-details
                                inset
                                label="Resumido:"
                              >
                                <template v-slot:label>
                                  <strong v-if="VentasVendedor.resumen == true" style="color: #000000">
                                    Resumido: Si
                                  </strong>
                                  <strong v-if="VentasVendedor.resumen == false" style="color: #000000">
                                    Resumido: No
                                  </strong>
                                </template>
                              </v-switch>
                            </v-col>

                            <v-col cols="12" md="6" sm="6">
                              <v-switch
                                v-if="$store.getters.GetdatosInfUsu.usuario.dsc"
                                v-model="VentasVendedor.dsc"
                                class="mt-0"
                                color="teal"
                                hide-details
                                inset
                                label="DSC:"
                                @change="changeDsc"
                              >
                                <template v-slot:label>
                                  <strong v-if="VentasVendedor.dsc == true" style="color: #000000">DSC: Si</strong>
                                  <strong v-if="VentasVendedor.dsc == false" style="color: #000000">DSC: No</strong>
                                </template>
                              </v-switch>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-col>
                      <!-- fn columna 2 -->
                    </v-row>
                  </v-form>
                </v-container>
                <hr />
                <ModalReporteFiltros :Datos="VentasVendedor" @DataReporteBasico="DDataReporteBasico" />
              </v-card>
            </v-container>
            <!-- fn Formulario-Ventas por Vendedor -->
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
          >
            <!--
                    <BarraBusqueda2
                          :url="$hostname + $hName + '/services/caja/findAll'"
                          :nombre="'Cajas'"
                          :headers="headers"
                          :slotname="'item.descripcion'"
                          :emitnombre="'emitCaja'"
                          :slotlist="slotlist"
                          :SeachNombre="'Búsqueda por descripción caja'"
                        /> -->
          </div>
        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      v-model="acti_tb_data"
      label="myAlert"
      max-height="100%"
      max-width="100%"
      persistent
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>
          <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color: #dd4b39"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" :items="list" :search="search" dense @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog v-model="Elim_notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn small @click.prevent="eliminar(), (Elim_notif.estado = !Elim_notif.estado)">
            <i class="fa fa-check" style="font-size: 20px"></i>
            Si
          </v-btn>

          <v-btn small @click.prevent="Elim_notif.estado = !Elim_notif.estado">
            <i class="fa fa-ban" style="font-size: 20px"></i>
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import { EventBus } from "../../event-bus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros"
  import {
    currencyFormatter,
    fechaNueva,
    FormatoFecha,
    getParamFecha,
    HoraFormatter,
    HoraFormatter2,
    RedondeoBasico,
    RedondeoValor,
    RedondeoValorCantRed,
  } from "@/js/Funciones.js"

  export default {
    components: {
      BarraBusqueda2,
      ContenidoBase,
      ModalReporteFiltros,
    },
    created() {
      var json = {
        titulo: "Ventas por Vendedor",
        descripcion: "Imprime las Ventas Generadas por Vendedor",
        save: false,
        eliminar: false,
        anular: false,
        nuevo: false,
        imprimir: false,
        accion: [
          "ReportesVentasVendedorNew",
          "ReportesVentasVendedorSave",
          "ReportesVentasVendedorRemove",
          "ReportesVentasVendedorAnular",
          "ReportesVentasVendedorPrintList",
        ],
      }
      EventBus.$emit("anularBotonesAccion", json)
    },
    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      EventBus.$on("ReportesVentasVendedorNew", this.new)
      EventBus.$on("ReportesVentasVendedorSave", this.save)
      EventBus.$on("ReportesVentasVendedorRemove", this.remove)
      EventBus.$on("ReportesVentasVendedorAnular", this.remove)
      EventBus.$on("ReportesVentasVendedorPrintList", this.imprimirList)
      EventBus.$on("emitReportesVentasVendedor", this.datostabla)
      this.cargarTodo()

      EventBus.$on("onResize", this.onResize)
    },

    data: () => ({
      // tipocomicion.add(new ComboUtil("Selección", 0));
      // tipocomicion.add(new ComboUtil("Comisión por venta", 1));
      // tipocomicion.add(new ComboUtil("Comisión por servicio", 2));

      RVendedores: [],
      RSucursal: [],
      RComision: [
        { codigo: 0, descripcion: "Selección" },
        { codigo: 1, descripcion: "Comisión por venta" },
        { codigo: 2, descripcion: "Comisión por servicio" },
      ],
      RCaja: [],
      tipoClienteList: [],

      ListaTiposClientes: [],
      windowSize: { width: "auto", height: "auto" },
      VentasVendedor: {
        desde: fechaNueva(),
        hasta: fechaNueva(),
        resumen: true,
        tipo: null,
        sucursal: null,
        vendedor: null,
        tipoCliente: null,
        subtipoCliente: null,
        nombre: "REPORTE VENTAS POR VENDEDOR",
        UrlImprimir: "/reportes-pv/ImprimirListVentasPorVendedor",
        UrlExel: "/reportes-pv/ExcelListVentasPorVendedor",
        UrlCorreo: "/reportes-pv/CorreoListVentasPorVendedor",
        dsc: false,
      },

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: false,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      text: "",
      valid: true,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:",
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" },
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?",
      },

      aalert: {
        estado: false,
        color: null,
      },
    }),

    //   destroyed() {
    //     location.reload();
    //   },
    methods: {
      currencyFormatter,
      FormatoFecha,
      HoraFormatter,
      HoraFormatter2,
      RedondeoValor,
      RedondeoBasico,
      RedondeoValorCantRed,
      fechaNueva,
      getParamFecha,
      onResize(e) {
        console.log("imprii ")

        console.log(e)
        this.windowSize = e
      },

      abrirTabla() {
        this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
      },
      async cargarTodo() {},
      datostabla(e) {
        this.VentasVendedor = e
        this.acti_tb_data = false
      },
      save() {},
      remove() {},
      eliminar() {},
      anular() {},
      imprimirList() {},
      newwnuevo() {},

      // Llamar a la API y obtener los datos de la API.
      cargarSucursal() {
        let headers = this.$store.getters.GetheadersAxios
        this.$axios
          .get(this.$hostname + this.$hName + "/sucursal/findallActivos/", { headers })
          .then((res) => (this.RSucursal = res.data))
      },

      cargarVendedores() {
        let headers = this.$store.getters.GetheadersAxios
        this.$axios
          .get(this.$hostname + this.$hName + "/vendedores/findallactiv", { headers })
          .then((res) => (this.RVendedores = res.data))
      },

      // Comprobando si el valor de la selección es nulo o indefinido.
      SelctCbSucursal() {
        if (this.VentasVendedor.sucursal == null) {
          this.VentasVendedor.sucursal = ""
        }

        if (this.VentasVendedor.sucursal.codigo == undefined) {
          this.alerta("Seleccione un sucursal", "error")
          this.VentasVendedor.sucursal = ""
          return
        }
      },

      SelctCbTipo() {
        var _this = this
        setTimeout(function () {
          if (_this.VentasVendedor.tipo == null) {
            _this.VentasVendedor.tipo = ""
          }

          if (!_this.VentasVendedor.tipo.hasOwnProperty("codigo")) {
            _this.VentasVendedor.tipo = ""
            _this.VentasVendedor.tipo = null
            return
          }
        }, 300)
      },

      BlurDesde() {
        if (this.VentasVendedor.desde.toString().length == 0) {
          this.VentasVendedor.desde = this.fechaNueva()
        }
      },

      BlurHasta() {
        if (this.VentasVendedor.hasta.toString().length == 0) {
          this.VentasVendedor.hasta = this.fechaNueva()
        }
      },

      changeDsc() {
        var _this = this
        setTimeout(function () {
          if (_this.VentasVendedor.tipo.codigo == 2) {
            _this.VentasVendedor.dsc = false
          }
        }, 300)
      },

      alerta(e, l) {
        if (l == "bien") {
          ;(this.aalert.estado = true), (this.aalert.color = "success"), (this.aalert.nombre = e)

          this.newwnuevo()
        }

        if (l == "error") {
          ;(this.aalert.estado = true), (this.aalert.color = "error"), (this.aalert.nombre = e)

          this.ejecucion = false
        }
      },

      actualiza_tb_ver() {
        this.acti_tb_data = !this.acti_tb_data
        this.filtro()
      },

      async filtro() {},
      //retorna datos del componente  reporte
      DDataReporteBasico() {},

      findAllTipoCliente() {
        this.$axios
          .get(this.$hostname + this.$hName + "/tipoclientes/findallActivo", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.tipoClienteList = res.data
          })
          .catch((error) => {
            console.error(error)
          })
      },
    },

    computed: {
      ActDescBtn() {
        this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))

        if (this.VentasVendedor.tipo == null) {
          this.VentasVendedor.tipo = this.RComision[0]
        }

        //EventBus.$emit("ActDesaBotones", objjct);
      },
    },

    watch: {
      "VentasVendedor.tipoCliente"(val) {
        if (!val) {
          this.VentasVendedor.subtipoCliente = null
        }
      },
    },
  }
</script>

<style></style>
